app.factory("$filter_autocomplete",function(_$filter){
    
    
    return {
        
      prefilter:function(scope){
          
         return scope.model.value; 
      },
      getTemplate:function(){
          
          return _$filter.getPath()+"/adapters/autocomplete.html";
      }  
        
    };
    
});

